if (!customElements.get('replacement-parts-section')) {
  customElements.define(
    'replacement-parts-section',
    class ReplacementPartsSection extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      abortController = undefined;
      mainProductSectionId = null;

      connectedCallback() {
        this.mainProductSectionId = document.querySelector('product-info[id^="MainProduct-"]')?.dataset?.section || null;

        if (FoxTheme?.pubsub?.subscribe) {
          this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.abortController?.abort();
      };

      handleVariantChange({ data }) {
        if (!data?.variant?.id) return;
        if (this.mainProductSectionId && data.sectionId !== this.mainProductSectionId) return;
        this.fetchSectionForVariant(data?.variant?.id);
      }

      fetchSectionForVariant(variantId) {
        if (!variantId || !this.dataset.sectionId) return;

        this.abortController?.abort();
        this.abortController = new AbortController();

        const sectionUrl = new URL(window.location.href);
        sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
        sectionUrl.searchParams.set('variant', String(variantId));

        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          const selectedOptionValues = Array.from(
            variantSelects.querySelectorAll('select option[selected], fieldset input:checked')
          )
            .map(({ dataset }) => dataset.optionValueId)
            .filter(Boolean);
          if (selectedOptionValues.length) {
            sectionUrl.searchParams.set('option_values', selectedOptionValues.join(','));
          }
        }

        fetch(sectionUrl.toString(), {
          signal: this.abortController.signal,
        })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const renderedSection = html.querySelector(`#shopify-section-${this.dataset.sectionId}`);
            const renderedContent = renderedSection?.querySelector('replacement-parts-section');

            if (!renderedContent) return;
            this.innerHTML = renderedContent.innerHTML;
            this.className = renderedContent.className;
          })
          .catch((error) => {
            if (error?.name === 'AbortError') return;
            console.error(error);
          });
      }
    }
  );
}
